import { literal, object, string } from 'superstruct';

import { ListResourceDto } from '@adflow/shared/util-data';
import { adflowApiSchema } from '@adflow/shared/util-route-schema';
import { parsableInteger } from '@adflow/shared/util-superstruct';

import { AddMediaDto } from './add-media.dto';
import { EditMediaDto } from './edit-media.dto';
import { ListMediaQueryDto } from './list-media-query.dto';
import { ViewMediaDto } from './view-media.dto';

const p = adflowApiSchema.prefix('media/google-ads');

export const ListGoogleAdsMedias = p.get('', {
	req: object({
		query: ListMediaQueryDto,
	}),
	res: ListResourceDto(ViewMediaDto),
});

export const GetGoogleAdsMedia = p.get(':mediaId', {
	req: object({
		params: object({ mediaId: parsableInteger() }),
	}),
	res: ViewMediaDto,
});

export const AddGoogleAdsMedia = p.post('', {
	req: object({
		body: AddMediaDto,
	}),
	res: object({
		file: ViewMediaDto,
		signedUrl: string(),
	}),
});

export const ProcessGoogleAdsMedia = p.post(':mediaId/process', {
	req: object({
		params: object({ mediaId: parsableInteger() }),
	}),
	res: ViewMediaDto,
});

export const EditGoogleAdsMedia = p.patch(':mediaId', {
	req: object({
		params: object({ mediaId: parsableInteger() }),
		body: EditMediaDto,
	}),
	res: ViewMediaDto,
});

// export const ArchiveGoogleAdsMedia = p.delete(':mediaId', {
// 	req: object({
// 		params: object({ mediaId: parsableInteger() }),
// 	}),
// 	res: literal(undefined),
// });

export const DeleteGoogleAdsMedia = p.delete(':mediaId', {
	req: object({
		params: object({ mediaId: parsableInteger() }),
	}),
	res: literal(undefined),
});
